export { zombiesDeck } from './zombies.js';
export { vampiresDeck } from './vampires.js';
export { sliversDeck } from './slivers.js';
export { eldraziDeck } from './eldrazi.js';
export { krakensDeck } from './krakens.js';
import { zombiesDeck } from './zombies.js';
import { vampiresDeck } from './vampires.js';
import { sliversDeck } from './slivers.js';
import { eldraziDeck } from './eldrazi.js';
import { krakensDeck } from './krakens.js';
export const HORDE_DECKS = [
    zombiesDeck,
    vampiresDeck,
    sliversDeck,
    eldraziDeck,
    krakensDeck,
];
//# sourceMappingURL=index.js.map